import { Component, OnInit } from '@angular/core';
import { IncidenciasService } from '../../services/incidencias.service';
import { CellHyperlinkCustomComponent } from '../cell-hyperlink-custom/cell-hyperlink-custom.component';
import { CellDateFormatterComponent } from '../cell-date-formatter/cell-date-formatter.component';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { error } from '@angular/compiler/src/util';

@Component({
  selector: 'app-incidencias',
  templateUrl: './incidencias.component.html',
  styleUrls: ['./incidencias.component.scss']
})
export class IncidenciasComponent implements OnInit {

  public translate: TranslateService;
  public rowData: any;
  public columnDefs: any[];
  private gridApi;
  private estado;

  createColumnDef() {
    const columnDefs = [
      {
        headerName: this.translate.instant('tasaciones.header_editar'), field: 'id', suppressFilter: true, suppressSorting: true,
        cellRendererFramework: CellHyperlinkCustomComponent,
        cellRendererParams: { destUrl: "/incidencias/edit/", hyperlinkText: "Editar" },
        pinned: 'left',
        width: 90,
        minWidth: 90
      },
      //{ headerName: this.translate.instant('tasaciones.header_estado'), field: 'estado.nombre' },
      { headerName: 'Actuación realizada', field: 'actuacionRealizada', minWidth: 150 },
      { headerName: 'Detalle', field: 'detalle', minWidth: 150},
      { headerName: this.translate.instant('incidencias.ag_cierre'), field: 'cierre', minWidth: 150},
      { headerName: 'Código tasación', field: 'codigoTasacion', minWidth: 150},
      //{ headerName: this.translate.instant('incidencias.ag_tasacionId'), field: 'tasacionId', minWidth: 150 },
      { headerName: 'Cliente', field: 'clienteName', minWidth: 150 },
      { headerName: 'Oficina facturación', field: 'oficina', minWidth: 150 },
      { headerName: this.translate.instant('incidencias.ag_fechaInicio'), field: 'fechaInicio', cellRendererFramework: CellDateFormatterComponent, minWidth: 150 },
      { headerName: this.translate.instant('incidencias.ag_fechaCierre'), field: 'fechaCierre', cellRendererFramework: CellDateFormatterComponent, minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.createdDate'), field: 'createdDate', cellRendererFramework: CellDateFormatterComponent, minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.createdByName'), field: 'createdByName', minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.updatedDate'), field: 'updatedDate', cellRendererFramework: CellDateFormatterComponent, minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.updatedByName'), field: 'updatedByName', minWidth: 150 },
      //{ headerName: this.translate.instant('incidencias.ag_id'), field: 'id', minWidth: 150 },
    ];

    return columnDefs;
  }

  constructor(private _IncidenciasService: IncidenciasService, private _router: Router, private _route: ActivatedRoute, private _authService: AuthService, _translateService: TranslateService) {
    this.translate = _translateService;

    this.columnDefs = this.createColumnDef();
  }

  ngOnInit() {
    this._route.data
      .subscribe(v => {
        if (v.estado != undefined) {
          this.estado = v.estado;
        }
      });

    this.getIncidencias();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  private getIncidencias() {
    this._IncidenciasService.getIncidencias(this.estado).subscribe(data => this.rowData = data), error => console.error("Error, no se ha podido recuperar datos.");
  }

}
